import { z } from "zod";

export const vendaItemSchema = z.object({
  tipo_produto_id: z.string().uuid("Produto inválido"),
  produto_nome: z.string().min(1, "Nome do produto é obrigatório"),
  quantidade: z.number().positive("Quantidade deve ser maior que zero"),
  unidade_medida: z.string().min(1, "Unidade é obrigatória"),
  preco_unitario: z.number().min(0, "Preço deve ser maior ou igual a zero"),
  desconto_percentual: z.number().min(0).max(100, "Desconto deve estar entre 0 e 100%").default(0),
  desconto_valor: z.number().min(0, "Desconto deve ser maior ou igual a zero").default(0),
  brinde: z.boolean().default(false),
  observacoes_item: z.string().optional(),
  subtotal: z.number().min(0, "Subtotal deve ser maior ou igual a zero"),
});

export const vendaSchema = z.object({
  data_venda: z.string().min(1, "Data da venda é obrigatória"),
  cliente_id: z.string().uuid().optional().nullable(),
  estabelecimento_id: z.string().uuid().optional().nullable(),
  forma_pagamento: z.enum([
    'Dinheiro',
    'Cartão de Crédito',
    'Cartão de Débito',
    'Pix',
    'Fiado',
    'Promocional'
  ], { required_error: "Forma de pagamento é obrigatória" }),
  status_pagamento: z.enum(['Pago', 'Pendente', 'Cancelado']).default('Pendente'),
  observacoes: z.string().optional(),
  responsavel_venda: z.string().optional(),
  canal_venda: z.enum(['aplicativo', 'presencial', 'delivery']).optional().nullable(),
  observacoes_gerais: z.string().optional(),
  numero_pedido: z.string().optional(),
  codigo_fiscal_cupom: z.string().optional(),
  data_entrega: z.string().optional().nullable(),
  situacao_entrega: z.enum(['em preparo', 'entregue', 'aguardando retirada']).optional().nullable(),
  subtotal: z.number().min(0).default(0),
  desconto_total: z.number().min(0).default(0),
  valor_frete: z.number().min(0).default(0),
  valor_total: z.number().min(0).default(0),
  itens: z.array(vendaItemSchema).min(1, "Adicione pelo menos um item à venda"),
}).refine((data) => data.desconto_total <= data.subtotal + data.valor_frete, {
  message: "Desconto total não pode ser maior que subtotal + frete",
  path: ["desconto_total"],
});

export type VendaFormData = z.infer<typeof vendaSchema>;
export type VendaItemFormData = z.infer<typeof vendaItemSchema>;
